import { Group, BoxHelper, Vector3 } from 'three';
import type { Object3D, Box3 } from 'three';

import type { AssemblyInstance } from '../loaders/assemblyInstance';
import type { AnyBody } from '../loaders/body';

export const boxesUnion = (
  boxes: Iterable<Box3>,
): { min: Vector3; max: Vector3 } => {
  const min = new Vector3();
  const max = new Vector3();
  for (const box of boxes) {
    min.min(box.min);
    max.max(box.max);
  }
  return { min, max };
};

export const prepareBoundBoxForObjects = (
  objects: Iterable<Object3D>, //Example: StepFaceModel, StepEdgeModel
): BoxHelper => {
  const grp = new Group();
  for (const obj of objects) {
    grp.add(new BoxHelper(obj));
  }
  const boundBox = new BoxHelper(grp);
  boundBox.geometry.computeBoundingBox();
  return boundBox;
};

export const prepareBoundBoxForBodies = (
  bodiesAndAssemblyInstances: Iterable<AnyBody | AssemblyInstance>,
): BoxHelper => {
  const grp = new Group();
  for (const bodyOrAssemblyInstance of bodiesAndAssemblyInstances) {
    if (bodyOrAssemblyInstance.isLoaded) {
      grp.add(bodyOrAssemblyInstance.boundBox);
    }
  }
  const boundBox = new BoxHelper(grp);
  boundBox.geometry.computeBoundingBox();
  return boundBox;
};
